<div id="brand_content_empty_view" [innerHTML]="htmlContent"></div>